import {LineStyle} from "../enums/line-style.enum";

export class LineStyleManager {
  public static DASH_PATH = 'M 0,-1 0,1';
  public static DOT_PATH = 'M 0.5,0.5 m -0.5, 0 a 0.5,0.5 0 1,0 1,0 a 0.5,0.5 0 1,0 -1,0';

  private dashedIcons = [{
    icon: {
      path: LineStyleManager.DASH_PATH,
      strokeOpacity: 1,
      strokeWeight: 0,
      strokeColor: '',
      scale: 4
    },
    offset: '0',
    repeat: '20px'
  }];

  private dottedIcons = [{
    icon: {
      path: LineStyleManager.DOT_PATH,
      strokeOpacity: 1,
      strokeWeight: 0,
      strokeColor: '',
      scale: 1,
    },
    offset: '0',
    repeat: '10px'
  }];

  private dashedFilled = [{
    icon: {
      path: LineStyleManager.DASH_PATH,
      strokeOpacity: 1,
      strokeWeight: 0,
      strokeColor: '#ffffff',
      scale: 4
    },
    offset: '0',
    repeat: '20px'
  }];

  private dottedFilled = [{
    icon: {
      path: LineStyleManager.DOT_PATH,
      strokeOpacity: 1,
      strokeWeight: 0,
      strokeColor: '#ffffff',
      scale: 1
    },
    offset: '0',
    repeat: '10px'
  }];

  private dashDot = [{
    icon: {
      path: LineStyleManager.DASH_PATH,
      strokeOpacity: 1,
      strokeWeight: 0,
      strokeColor: '',
      scale: 4
    },
    offset: '0',
    repeat: '30px'
  },
    {
      icon: {
        // path: this.DOT_PATH,
        // scale: 1,
        path: LineStyleManager.DOT_PATH,
        fillOpacity: 1,
        strokeOpacity: 1,
        strokeWeight: 0,
        strokeColor: '',
        scale: 1
      },
      offset: '15px',
      repeat: '30px'
    }
  ];

  getPolygonLineIcons(style: LineStyle, lineColor: string, lineWidth: number) {
    switch (style) {
      case LineStyle.DASHED:
        this.dashedIcons[0].icon.strokeWeight = lineWidth;
        this.dashedIcons[0].icon.strokeColor = lineColor;
        return this.dashedIcons;
      case LineStyle.DOTTED:
        this.dottedIcons[0].icon.strokeWeight = lineWidth;
        this.dottedIcons[0].icon.strokeColor = lineColor;
        return this.dottedIcons;
      // The two legacy styles have no pattern of their own; they draw as the
      // style the .mmp legacy code table gives them (mmp-format.ts
      // LINE_STYLE_TO_CODE), so the web and the mobile apps agree.
      case LineStyle.DASH_DASH_DOT:
      case LineStyle.DASHED_FILLED:
        this.dashedFilled[0].icon.strokeWeight = lineWidth * 0.8;
        return this.dashedFilled;
      case LineStyle.DASH_DOT_DOT:
      case LineStyle.DOTTED_FILLED:
        this.dottedFilled[0].icon.strokeWeight = lineWidth * 0.8;
        return this.dottedFilled;
      case LineStyle.DASH_DOT:
        this.dashDot[0].icon.strokeWeight = lineWidth;
        this.dashDot[1].icon.strokeWeight = lineWidth;
        this.dashDot[0].icon.strokeColor = lineColor;
        this.dashDot[1].icon.strokeColor = lineColor;
        return this.dashDot;
      // this.dashedIcons[0].icon.strokeWeight = lineWidth;
      // this.dashedIcons[0].icon.strokeColor = lineColor;
      // this.dashedIcons[0].offset = '10px';
      // this.dottedIcons[0].icon.strokeWeight = lineWidth;
      // this.dottedIcons[0].icon.strokeColor = lineColor;
      // this.dottedIcons[0].offset = '10px';
      // return [
      //   this.dashedIcons[0],
      //   this.dottedIcons[0]
      // ]

      // case LineStyle.DASH_DOT_DOT:
      //   this.dashedIcons[0].icon.strokeWeight = lineWidth;
      //   this.dashedIcons[0].icon.strokeColor = lineColor;
      //   this.dottedIcons[0].icon.strokeWeight = lineWidth;
      //   this.dottedIcons[0].icon.strokeColor = lineColor;
      //   // return [this.dashedIcons[0], this.dottedIcons[0], this.dottedIcons[0]];
      //   return [
      //     {
      //       icon: this.lineSymbol,
      //       offset: '0',
      //       repeat: '20px'
      //     },
      //     {
      //       icon: this.dotSymbol,
      //       offset: '20px',
      //       repeat: '20px'
      //     },
      //     {
      //       icon: this.lineSymbol,
      //       offset: '40px',
      //       repeat: '20px'
      //     }
      //   ]
      default:
        return undefined;
    }
  }
}
